<div class="SLV2-main-wrapper">
    <div class="SLV2-tpcsumry-full-wrap">

        <!-- header start -->
        <div class="SLV2-tpcsumry-hdr">
            <div class="SLV2-tpcsumry-hdr-title-row">
                <button class="SLV2-tpcsumry-close-btn" (click)="quitRevision()">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/close-white-icon.svg" />
                </button>
                <h3 class="SLV2-tpcsumry-hdr-title">{{getTopicName()}}</h3>
            </div>
            <div class="SLV2-tpcsumry-hdr-progressbar">
                <span [style.width]="((completedCount) / (topicSummaryList?.length+1))*100 +'%'"></span>
            </div>
            
        </div>
        <!-- header ended -->

        <div class="SLV2-tpcsumry-dtl-colwrap">
            <div class="SLV2-tpcsumry-lft-area">
                <div class="SLV2-tpcsumry-content-row">
                    <div class="SLV2-tpcsumry-content-wrap">
                        <ng-container *ngFor="let item of topicSummaryList; let i = index">
                            <ng-container *ngIf="i == defaultTopicSammary">
                                <div class="SLV2-tpcsumry-big-img-wrap" (click)="openViewImageDialog(item)">
                                    <img src="{{getMedia(item)}}" />
                                </div>
                                <div class="SLV2-tpcsumry-title-area">
                                    <h3>{{item.title}}</h3>
                                    <!-- <ng-container *ngTemplateOutlet="bookmark"></ng-container> -->
                                </div>
                                

                                <div class="SLV2-play-user-actn-row">
                                    <ng-container *ngTemplateOutlet="likeDislike"></ng-container>
                                    <ng-container *ngTemplateOutlet="bookmark"></ng-container> 
                                </div>


                                <div class="SLV2-tpcsumry-data-para" [ngClass]="{'expand': ViewMoreStatus}" [innerHTML]="item.description"></div>

                                <div class="SLV2-section-action-area" >
                                    <button class="SLV2-subject-view-more-btn blue" [ngClass]="{'expanded' : ViewMoreStatus}"
                                        (click)="ViewMoreButton()">
                                        <ng-container *ngIf="!ViewMoreStatus">view more</ng-container>
                                        <ng-container *ngIf="ViewMoreStatus">view less</ng-container>
                                        <img src="selflearnv2-ui/assets/img/profile-drop-down-arrow.svg" />
                                    </button>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <div class="SLV2-tpcsumry-content-actn-row">
                    <div class="SLV2-tpcsumry-actn-graybox">
                        <div class="SLV2-tpcsumr-mob-like-area">
                            <!-- <ng-container *ngTemplateOutlet="likeDislike"></ng-container> -->
                        </div>
                        <div class="SLV2-change-topic-btn-group">
                            <button class="SLV2-tpcsumry-arrow-btn prev-topic-button" (click)="prevTopic()" [disabled]="disablePrev"><img src="selflearnv2-ui/assets/img/self-learn-v2/left-blue-arrow.svg" /></button>
                            {{selectedFlashCardData.flashcardTaggedQuestionsCount>0 ? (defaultTopicSammary + 1)+"/"+(topicSummaryList.length + 1) : (defaultTopicSammary + 1)+"/"+(topicSummaryList.length)}}
                            <!-- {{defaultTopicSammary + 1 | number:'2.0-2'}}/{{topicSummaryList.length + 1| number:'2.0-2'}} -->
                            <button class="SLV2-tpcsumry-arrow-btn next-topic-button" (click)="nextTopic()" [disabled]="disableNext"><img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                        </div>
                        
                    </div>
                </div>
            </div>
            <app-topic-sidebar [completedCount]="completedCount" [TopicSummaryData]="topicSummaryList" 
            [currentTopicIndex]="defaultTopicSammary" (topicSelected)="onTopicSelected($event)" [selectedFlashCardData]="selectedFlashCardData" [isRevisionQuestionsCompleted]="isAllRevisionQuesionsCompleted" [taggedQuestionIds]="questionIds"></app-topic-sidebar>
        </div>
    </div>
</div>



<ng-template #likeDislike>
    <button class="SLV2-user-btn like-btn">
        <div class="SLV2-btn-icon" [ngClass]="{'active':topicSummaryList[defaultTopicSammary].isLiked}" (click)="userLike()">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/like-icon.svg" />
            <img src="selflearnv2-ui/assets/img/self-learn-v2/like-fill-icon.svg" class="color" />
        </div>
        <!-- <span>202</span> -->
    </button>
    <button class="SLV2-user-btn dislike-btn">
        <div class="SLV2-btn-icon" [ngClass]="{'active':topicSummaryList[defaultTopicSammary].isDisLiked}" (click)="userDislike()">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/dislike-icon.svg" />
            <img src="selflearnv2-ui/assets/img/self-learn-v2/dislike-fill-icon.svg" class="color" />
        </div>
        <!-- <span>Dislike</span> -->
    </button>
</ng-template>

<ng-template #bookmark>
<button class="SLV2-user-btn right-btn" (click)="bookMarkSummaryProgress(!topicSummaryList[defaultTopicSammary].isBookmarked)">
    <div class="SLV2-btn-icon bookmark" *ngIf="!topicSummaryList[defaultTopicSammary].isBookmarked">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/bookmark-line-icon.svg" />
    </div>
    <div class="SLV2-btn-icon bookmark"  *ngIf="topicSummaryList[defaultTopicSammary].isBookmarked">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/bookmark-icon.svg" />
    </div>
    <!-- <span>Share</span> -->
</button>
</ng-template>
